export default {
  state: {
    meta: '',
    title: '',
    page_info_brand: '',
    page_info_title: '',
    metaHighestReview: '',
    categoriesOfDepartment: '',
    isOffCanvasOpen: false,
    mobile: {
      activeIndexGrandParent: -1,
      activeIndexParent: -1,
      activeIndexChild: -1,
    },
    primaryMenuMobileActive: '',
    listCategoryMobile: '',
    tabCategoryActive: '',
    tabCategoryActiveName: '',
    showCategoriesMobile: false,
  },
  mutations: {
    closeOffCanvas(state) {
      state.isOffCanvasOpen = false;
    },
    openOffCanvas(state) {
      state.isOffCanvasOpen = true;
    },
    setDataCategoriesOfDepartment(state, dataCategoriesOfDepartment) {
      state.categoriesOfDepartment = dataCategoriesOfDepartment;
    },
    setDataChildrenOfCategoriesDepartment(state, { data, categoriesOfDepartmentKey }) {
      this._vm.$set(state.categoriesOfDepartment[categoriesOfDepartmentKey], 'children', data);
    },
    updateActiveIndexChild(state, index) {
      state.mobile.activeIndexChild = index;
    },
    updateActiveIndexGrandParent(state, index) {
      state.mobile.activeIndexGrandParent = index;
    },
    updateActiveIndexParent(state, index) {
      state.mobile.activeIndexParent = index;
    },
    updatePrimaryMenuMobile(state, value) {
      state.primaryMenuMobileActive = value;
    },
    setHeaderMeta(state, value) {
      state.meta = value;
    },
    setTitle(state, value) {
      state.title = value;
    },
    setPageInfo(state, data) {
      state.page_info_brand = data.brand;
      state.page_info_title = data.title;
    },
    setMetaHighestReview(state, value) {
      state.metaHighestReview = value;
    },
    SET_LIST_CATEGORY_MOBILE(state, data) {
      state.listCategoryMobile = data;
    },
    SET_TAB_CATEGORY_ACTIVE(state, data) {
      state.tabCategoryActive = data;
    },
    SET_TAB_CATEGORY_ACTIVE_NAME(state, data) {
      state.tabCategoryActiveName = data;
    },
    SET_SHOW_CATEGORY(state, data) {
      state.showCategoriesMobile = data;
    },
  },
  actions: {
    // getCategoriesShopByDepartments({ commit }) {
    //   return this._vm
    //     .$MS_SOCO_PUBLIC_API_URL(`product/categories/Shop%20By%20Departments`, {
    //       params: {
    //         section: 'getCategoriesShopByDepartments',
    //         filter: {
    //           is_featured: true,
    //         },
    //       },
    //     })
    //     .then((response) => {
    //       if (response.status === 200) {
    //         this._vm.$SO.each(response.data.data, (key, department) => {
    //           response.data.data[key].isOpenDepartment = false;
    //           response.data.data[key].indexArray = key;
    //         });
    //         commit('setDataCategoriesOfDepartment', response.data.data);
    //         return response.data.data;
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    getCategoriesShopByDepartments({ commit }) {
      return this._vm
        .$MS_CATALOG_API_URL(`/v3/categories/children`, {
          params: {
            filter: {
              name: 'Shop By Departments',
              depth: 3,
            },
            fields:
              'name,my_soco_sql_id,my_sociolla_sql_id,link_rewrite,parents,slug,banner_for_sociolla,logo,is_featured',
            skip: 0,
            limit: 10,
            sort: 'position',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const list = {};
            const categories = [];
            response.data.data.children.forEach((category, key) => {
              if (response.data.data.children[key].slug) {
                categories.push(category);
              }
            }) || [];

            const copyWithValueDepartmentMenu = response.data.data.children
              ? JSON.parse(JSON.stringify(response.data.data.children))
              : {};

            if (copyWithValueDepartmentMenu && Object.keys(copyWithValueDepartmentMenu).length) {
              copyWithValueDepartmentMenu.forEach((department, keyDepartment) => {
                list[department['_id']] = [];
                if (department.children && department.children.length) {
                  department.children.forEach((category, keyCategory) => {
                    category.departmentName = department.name;
                    category.departmentSlug = department.slug;
                    list[department['_id']].push(category);
                    category.children.forEach((subcategory, keySubcategory) => {
                      list[department['_id']].push(subcategory);
                    });
                  });
                }
              });
            }
            commit('setDataCategoriesOfDepartment', categories);
            commit('SET_LIST_CATEGORY_MOBILE', list);
            return categories;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getChildrenOfDepartments({ commit }, { categoryName, categoriesOfDepartmentKey }) {
      return this._vm
        .$MS_CATALOG_API_URL(`/v3/categories/children`, {
          filter: {
            name: categoryName,
            depth: 3,
            is_featured: true,
          },
          fields:
            'name,my_soco_sql_id,my_sociolla_sql_id,link_rewrite,parents,slug,banner_for_sociolla,logo,is_featured',
          skip: 0,
          limit: 10,
          sort: 'position',
        })
        .then((response) => {
          if (response.status === 200) {
            // this._vm.$SO.each(response.data.data, (key, parent) => {
            //   response.data.data[key].indexArray = key;
            //   this._vm.$SO.each(response.data.data[key].sub_categories, (keyChild, child) => {
            //     response.data.data[key].sub_categories[keyChild].indexArray = keyChild;
            //   });
            // });
            // const subcategories = (response.data.data || []).filter((item) => {
            //   if(item.sub_categories.length){
            //     item.sub_categories = item.sub_categories.filter((entry, index) => item.sub_categories.indexOf(entry) === index && entry.my_sociolla_sql_id);
            //   }
            //   return item;
            // });
            //  console.log(subcategories)
            commit('setDataChildrenOfCategoriesDepartment', {
              data: response.data.data,
              categoriesOfDepartmentKey: categoriesOfDepartmentKey,
            });
            return response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  getters: {},
};
